import type {
  RollbackCommandData as LegalEntityCommandData,
  RollbackCommandDataVFrame as LegalEntityRollbackCommandDataVFrame,
} from '@festina/legalentity-general-types/legalentity'
import type {
  RollbackCommandData as LifeCommandData,
  RollbackCommandDataVFrame as LifeRollbackCommandDataVFrame,
} from '@festina/life-general-types/life'
import { type Except, type Optional, typeUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeForm } from '../forms/LifeForm'
import { initialFormEntriesFromVBase } from '../forms/yup/validation/yupValidationUtils'
import { LifeInput } from '../inputs/LifeInput'

type RollbackCommandData = LifeCommandData | LegalEntityCommandData

const validateKey = typeUtils.createValidator<RollbackCommandData>()

type Props = {
  frame: Optional<
    LifeRollbackCommandDataVFrame | LegalEntityRollbackCommandDataVFrame
  >
} & Except<CommandDataFormProps<RollbackCommandData>, 'shouldSkipFrame'>

export const RollbackCommandForm = ({
  commandData,
  frame,
  ...props
}: Props) => {
  const translate = useTranslate()

  const defaultValues: RollbackCommandData = {
    _type: 'RollbackCommandData',
    ...initialFormEntriesFromVBase(frame),
  }

  return (
    <LifeForm initialValues={defaultValues} frame={frame} {...props}>
      <LifeInput
        fallbackInputType="date"
        name={validateKey('rollbackTo')}
        label={translate('rollbackForm.rollbackTo')}
      />
      <LifeInput
        fallbackInputType="string"
        name={validateKey('reason')}
        label={translate('rollbackForm.reason')}
      />
    </LifeForm>
  )
}
